import React from 'react';
import Tinyscroll from '../helpers/Tinyscroll';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getLearningRoom } from '../actions/learningRoomAction';
import * as Common from '../helpers/Common';

class Left extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      learningroom: [],
      modular_path: [],
      modular_lrs: [],
      is_guided_path: '',
      is_modular_path: '',
      display_order: ''
    };
  }
  switchComponentPanel(type, lr_id, dlr_id, prerequisite_status) {
    if (prerequisite_status == '1') {
      this.props.onClick(type, lr_id, dlr_id);
    } else {
      Common.message('Note!', prerequisite_status, 'info');
    }
  }
  getLearningRoom() {
    if (!Common.isAccordionInit()) {
      Common.showLargeLeftMenu();
      Common.winResize();
      Common.ddaccordionInIt(this.props.leftMenuType);
      Common.showconleft();
      Common.contentResizeLoad();
      Common.updateScrollLeft();
      Common.reactLoaderk("hide");
    }
  }
  modulefunction(lr_id) {
    let strv = this.state.modular_lrs[lr_id].map((key, index) => {
      return <li key={`strv_${index}`} id={'md' + key.lr_id} className={`mlr_${key.lr_id}`} >
        <a key={'amod' + key.lr_id} onClick={e => this.switchComponentPanel('componet_list', key.lr_id, key.dlr_id, key.prerequisite_status)} href="javascript:void(0);">
          <div className="num">{index + 1}</div>
          <div className="txt">{key.lr_name}
            <span className={key.lr_status}></span>
          </div>
        </a>
      </li>
    });
    return strv;
  }
  modulefunctionres(lr_id) {
    let strv = this.state.modular_lrs[lr_id].map((key, index) => {
      return <li key={`mods_${index}`} id={'mds' + key.lr_id} className={`mrlr_${key.lr_id}`}>
        <a key={'amods' + key.lr_id} onClick={e => this.switchComponentPanel('componet_list', key.lr_id, key.dlr_id, key.prerequisite_status)} href="javascript:void(0);">
          <div className="num">{index + 1}</div>
          <div className="txt"></div>
        </a>
      </li>
    });
    return strv;
  }
  componentDidMount() {
    Common.reactLoaderk("show", "please wait...");
    this.props.getLearningRoom();
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      learningroom: nextProps.learningRoom.lr_list,
      modular_path: nextProps.learningRoom.modular_path,
      modular_lrs: nextProps.learningRoom.modular_lrs,
      is_guided_path: nextProps.learningRoom.is_have_guided_path,
      is_modular_path: nextProps.learningRoom.is_have_modular_path,
      display_order: nextProps.learningRoom.guided_modular_display_order
    });
    setTimeout(() => {
      this.getLearningRoom();
    }, 100);
  }
  render() {
    let lr_count = 0,
      modul_lr_count = 0;
    
    const lr_rooms = this.state.learningroom.map((key, index) => {
      let lid = key.lr_id;
      return <li key={`lr_rooms_${index}`} id={"lr" + key.lr_id} className={"lr" + key.lr_id + " " + key.style_class}>
        <a onClick={e => this.switchComponentPanel('componet_list', key.lr_id, key.dlr_id, key.prerequisite_status)} href="javascript:void(0);">                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         
          <div className="num">{index + 1}</div>
          <div className="txt">{key.lr_name} <span className={key.lr_status}></span></div>
        </a>
      </li>
    })
    const lr_rooms_response = this.state.learningroom.map((key, index) => {
      let lid = key.lr_id;
      lr_count = index + 1;
      return <li key={`lr_rooms_response_${index}`} id={"lr" + key.lr_id} className={`lr${key.lr_id} ${key.style_class}`}>
        <a onClick={e => this.switchComponentPanel('componet_list', key.lr_id, key.dlr_id, key.prerequisite_status)} href="javascript:void(0);">
          <div className="num">{lr_count}</div>
        </a>
      </li>
    })
    const module_dlrooms = Object.keys(this.state.modular_path).map((mk, index) => {
      let modu = this.state.modular_path[mk],
        mid = modu.module_id;
      return <li key={`module_dlrooms_${index}`} id={modu.module_name} className={'modularcs ' + modu.style_class} >
        <a href="javascript:void(0);">
          <div className="num"></div>
          <div className="txt">{modu.module_name}</div>
        </a>
        <ul>{this.modulefunction(mid)}</ul>
      </li>
    })
    const module_dlrooms_response = Object.keys(this.state.modular_path).map((mk, index) => {
      let modu = this.state.modular_path[mk],
        mid = modu.module_id;
      modul_lr_count = index + 1;
      return <li key={`module_dlrooms_response_${index}`} id={modu.module_name} className={'modularcs ' + modu.style_class}>
        <a href="javascript:void(0);">
          <div className="num"></div>
          <div className="txt"></div>
        </a>
        <ul>{this.modulefunctionres(mid)}</ul>
      </li>
    })

    const smallGuidedMenu = <div>
      <div className="silverheader">
        <a title="Guided Path" alt="Guided Path" className="guide lr-small"></a>
      </div>
      <div className="submenu" id="lr-wise-small">
        <section id="semana-scroll-left" className="scrollbar1">
          <section className="scrollbar" style={{ display: 'none' }}>
            <section className="track">
              <section className="thumb"></section>
            </section>
          </section>
          <section className="viewport viewport2">
            <section className="overview guided_path">
              <ul>{lr_rooms_response}</ul>
            </section>
          </section>
        </section>
      </div>
    </div>

    const smallModularMenu = <div>
      <div className="silverheader">
        <a title="Modular Path" alt="Modular Path" className="module module-small"></a>
      </div>
      <div className="submenu" id="module-wise-small">
        <section id="semana-scroll-left1" className="scrollbar1">
          <section className="scrollbar" style={{ display: 'none' }}>
            <section className="track">
              <section className="thumb"></section>
            </section>
          </section>
          <section className="viewport">
            <section id="module-wise" className="overview guided_path">
              <ul>{module_dlrooms_response}</ul>
            </section>
          </section>
        </section>
      </div>
    </div>

    const largeGuidedMenu = <div>
      <div className="silverheader">
        <a title="Guided Path" alt="Guided Path" className="guide lr-big">
          <span>Guided Path <div className="sub">Recommended learning sequence</div></span>
        </a>
      </div>
      <div className="submenu" id="lr-wise-big">
        {/* <Tinyscroll count={lr_count} selector="lr2_scroll_guided"> */}
          <section className="viewport">
            <section className="overview guided_path">
              <ul>{lr_rooms}</ul>
            </section>
          </section>
        {/* </Tinyscroll> */}
      </div>
    </div>

    const largeModularMenu = <div>
      <div className="silverheader">
        <a title="Modular Path" alt="Modular Path" className="module module-big">
          <span>Learning Modules <div className="sub">Topic-wise components</div></span>
        </a>
      </div>
      <div className="submenu" id="module-wise-big">
        { /*<Tinyscroll count={modul_lr_count} selector="lr3_scroll_dlr"> */}
          <section className="viewport">
            <section id="module-wise" className="overview guided_path">
              <ul>{module_dlrooms}</ul>
            </section>
          </section>
       { /*</Tinyscroll>  */}
      </div>
    </div>

    return (
      <div className="leftposstatic">
        <div id="toggle-left" className="toggle-left toggle-left-mbl">
          <a id="leftmenuarrow" className="showconleft openarrow"></a>
        </div>

        <div className="applemenu menusmall" id="menusmall" style={{ display: 'none' }}>
          <div id="toggle-left" className="toggle-left">
            <a id="leftmenuarrow" className="showconleft closearrow"></a>
          </div>
          {
            this.state.display_order === 1 && this.state.is_guided_path === 1 &&
            smallGuidedMenu
          }
          {
            this.state.is_modular_path === 1 &&
            smallModularMenu
          }
          {
            this.state.display_order === 2 && this.state.is_guided_path === 1 &&
            smallGuidedMenu
          }
        </div>

        <section id="leftnavsec" className="left-nav" style={{ display: 'none' }}>
          <div id="toggle-left" className="toggle-left">
            <a id="leftmenuarrow" className="showconleft openarrow"></a>
          </div>
          <div className="applemenu" id="menularge">
            {
              this.state.display_order === 1 && this.state.is_guided_path === 1 &&
              largeGuidedMenu
            }
            {
              this.state.is_modular_path === 1 &&
              largeModularMenu
            }
            {
              this.state.display_order === 2 && this.state.is_guided_path === 1 &&
              largeGuidedMenu
            }
          </div>
        </section>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return { learningRoom: state.learningRoom };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ getLearningRoom }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(Left);



// WEBPACK FOOTER //
// ./src/partials/Left.js